"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const building_blocks_ui_common_1 = require("@acko-tech/building-blocks.ui.common");
const utils_1 = require("./utils");
const SubHeading = building_blocks_ui_common_1.styled.p `
  ${(0, utils_1.getStyles)({
    fontWeight: building_blocks_ui_common_1.$fontWeightBold,
    color: building_blocks_ui_common_1.$neutralColors.dark
})};
  font-size: ${props => (0, utils_1.getFontSize)(props.size)};
  ${props => props &&
    props.colorVariant &&
    `color: ${(0, utils_1.getFontColorVariant)(props.colorVariant)}`};
`;
exports.default = SubHeading;
//# sourceMappingURL=subHeading.js.map